
export const VERSION = '5.7.0'; // Update this manually on each release


